module.exports = "/layout/app/images/logo-payment-stripe-card.d10f9f33.svg";